module.exports = __webpack_public_path__ + "img/MM.45a37eb6.svg";